import { useQuery } from "@tanstack/react-query";
import { rankingApi } from "@bw/shared/api";
import type { PlayerStatsResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The authenticated player's own aggregate stats (GET /ranking/stats/me).
 * Server-computed win rates — StatsPanel renders them verbatim and shows "—"
 * for an honest zero-games state.
 */
export function useMyStats() {
  return useQuery<PlayerStatsResponse>({
    queryKey: queryKeys.compete.myStats(),
    queryFn: () => rankingApi.getMyStats(),
  });
}
